import { useSelector } from 'react-redux'
import { createSelector } from 'reselect'

import { isMutualAvailabilityLoginEnabledSelector } from 'selectors/mutual_availability'
import { recentUserSelector } from 'selectors/user'

export const useMutualAvailabilityLoginEnabled = () => useSelector(
  createSelector(
    recentUserSelector,
    isMutualAvailabilityLoginEnabledSelector,
    (recentUser, enabled) => recentUser && enabled
  )
)
